module.exports = __webpack_public_path__ + "assets/新增客源.cdc5a4df.svg";